function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "_2-Dashboard_Design-Final-Copy-2",
  "data-name": "2-Dashboard_Design-Final-Copy-2",
  transform: "translate(-32 -373)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-7",
  transform: "translate(32 373)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle",
  d: "M.5,0h17a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5H.5A.5.5,0,0,1,0,2.5V.5A.5.5,0,0,1,.5,0Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  d: "M16.7,4a.3.3,0,0,1,.3.3h0V15.7a.3.3,0,0,1-.3.3H1.3a.3.3,0,0,1-.3-.3H1V4.3A.3.3,0,0,1,1.3,4H16.7ZM11.21,5.286H6.7a.3.3,0,0,0-.3.3h0V6.32a.3.3,0,0,0,.3.3H11.21a.3.3,0,0,0,.3-.3h0V5.586a.3.3,0,0,0-.3-.3Z",
  fillRule: "evenodd"
})));

var SvgProducts = function SvgProducts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "#fff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProducts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/products.463155e6.svg";
export { ForwardRef as ReactComponent };